<template>
  <div class="container mx-auto bg-white shadow rounded p-10 flex flex-col text-center text-gray-500">

    <div class="p-2 text-6xl">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </div>

    <h3  class="p-2">{{ title }}</h3>

    <p  class="p-2">{{ message }}</p>

    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'box-entity-empty',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default () { return 'file' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/box-empty.vue